import React from 'react'

import { NumbersListStyled, NumbersListItemStyled } from './styles'
import { NumbersListProps } from './types'

import NumberItem from '../../molecules/NumberItem'

const NumbersList: React.FC<NumbersListProps> = ({ data }) => {
  const { list, itemsPerRow } = data
  return (
    <NumbersListStyled>
      {list.map(({ number, currency, title, caption, isAlt, isHorizontal, numberAltFont }) => (
        <NumbersListItemStyled
          key={number}
          sx={{
            width: ['100%', 'calc(100% / 3)', `calc(100% / ${itemsPerRow && itemsPerRow <= 5 ? itemsPerRow : 3})`]
          }}
        >
          <NumberItem {...{ number, currency, title, caption, isAlt, isHorizontal, numberAltFont }} />
        </NumbersListItemStyled>
      ))}
    </NumbersListStyled>
  )
}

export default NumbersList
